/**
 * resolveActionRoute — maps ActionRoute symbolic targets to actual admin paths.
 *
 * This is the only place that knows how symbolic route targets become URLs.
 * Components call this with (route, shopId) and get a path for history.push().
 */

import { ActionRoute } from './operatorState';
import { ROUTES } from '../../app/routes/routeMap';

const ROUTE_MAP = {
  [ActionRoute.DIAGNOSTICS]: ROUTES.diagnostics,
  [ActionRoute.WIZARD_WELCOME]: ROUTES.setup,
  [ActionRoute.WIZARD_EXPERIENCE]: ROUTES.setup,
  [ActionRoute.WIZARD_THEME]: ROUTES.setup,
  [ActionRoute.WIZARD_BUILD]: ROUTES.setup,
  [ActionRoute.INTEGRATION_SETTINGS]: (shopId) => ROUTES.searchSettings(shopId, 'theme'),
  [ActionRoute.HOME_ACTIVATE]: () => null, // inline action — dispatched by component, not navigated
  [ActionRoute.HOME_INDEX]: (shopId) => ROUTES.searchSettings(shopId, 'data'),
  [ActionRoute.HOME_OPEN_PREVIEW]: () => null, // inline action — component opens preview, not navigated
  [ActionRoute.HOME_PUBLISH]: () => null, // inline action — component handles publish
};

export function resolveActionRoute(route, shopId) {
  if (!route) return null;
  const resolver = ROUTE_MAP[route];
  return resolver ? resolver(shopId) : null;
}
